import * as React from "react";
import styles from "./styles.css.js";
export function Skeleton({ notifications, content }) {
    return (React.createElement("main", { className: styles.root },
        React.createElement("section", { className: styles.toolbar }),
        notifications && React.createElement("div", { className: styles.notifications }, notifications),
        React.createElement("div", { className: styles.content }, content)));
}
